// extracted by mini-css-extract-plugin
export default {"downloadStatus":"RequestDataButton_downloadStatus__ECFFJ","statusRow":"RequestDataButton_statusRow__MzQUD","statusColumn":"RequestDataButton_statusColumn__PiYv6"};